export default __webpack_public_path__ + "files/7871adc1f4a5d56ac0c81e41c88b52b2.mp3";